import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-12 md:py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-124">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="relative rounded-3xl bg-primary-card border border-accent-cyan/30 p-1 overflow-hidden" data-id="element-125">
        {/* Animated border effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-accent-cyan/0 via-accent-cyan/50 to-accent-cyan/0 opacity-20 animate-[spin_4s_linear_infinite] blur-xl" data-id="element-126"></div>

        <div className="relative bg-primary-card rounded-[23px] p-6 md:p-10 flex flex-col items-center text-center z-10" data-id="element-127">
          <div className="bg-accent-orange text-primary font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-wider mb-6 animate-pulse" data-id="element-128">
            El precio de lanzamiento termina hoy.
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-129">
            PACK QUÍMICA TOTAL 360
          </h2>
          <h3 className="text-xl text-text-muted mb-6" data-id="element-130">
            16 Tomos • Sistema Completo
          </h3>

          <div className="mb-6 flex flex-col items-center" data-id="element-131">
            <span className="text-2xl text-text-muted line-through decoration-accent-red/50 decoration-2 mb-2" data-id="element-132">
              $60.000
            </span>
            <div className="flex items-start gap-2" data-id="element-133">
              <span className="text-5xl md:text-7xl font-heading font-bold text-accent-cyan" data-id="element-134">
                $24.990
              </span>
              <span className="text-xl text-accent-cyan font-bold mt-2" data-id="element-135">
                ARS
              </span>
            </div>
          </div>

          <ul className="space-y-3 mb-8 text-left w-full max-w-md mx-auto" data-id="element-136">
            {['Acceso de por vida a las 4 tecnicaturas', 'Cuadernillos listos para imprimir', 'Garantía de satisfacción 7 días'].map((benefit, index) => <li key={index} className="flex items-center gap-3 text-lg" data-id="element-137">
                <div className="bg-accent-green/20 p-1 rounded-full shrink-0" data-id="element-138">
                  <Check className="w-5 h-5 text-accent-green" data-id="element-139" />
                </div>
                <span data-id="element-140">{benefit}</span>
              </li>)}
          </ul>

          <motion.a href="https://checkout.guiadigital360.online/cart/44924930719813:1" target="_blank" rel="noopener noreferrer" animate={{
          boxShadow: ['0 0 20px rgba(0, 200, 83, 0.3)', '0 0 40px rgba(0, 200, 83, 0.6)', '0 0 20px rgba(0, 200, 83, 0.3)'],
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-full max-w-md bg-accent-green hover:bg-[#00b34a] text-primary font-bold text-xl px-8 py-5 rounded-xl transition-all transform hover:scale-105 inline-block text-center" data-id="element-141">
            SÍ, QUIERO EL SISTEMA TOTAL 360
          </motion.a>
        </div>
      </motion.div>
    </section>;
}